import { Box, CircularProgress } from '@mui/material'

export default function LoadingScreen() {
  return (
    <Box sx={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
      <CircularProgress size={28} />
    </Box>
  )
}
